import { useEffect, useRef } from 'react'

import { emptyWedge, feedKey, isTyping, type WedgeState } from './wedge'

/**
 * Listen for a keyboard-wedge scanner anywhere in the app.
 *
 * Keystrokes into a field are left alone — a wedge aimed at a search box should
 * fill the search box, not teleport the page away underneath it.
 */
export function useKeyboardWedge(onCode: (code: string) => void, enabled = true) {
  const handler = useRef(onCode)
  handler.current = onCode

  useEffect(() => {
    if (!enabled) return
    let state: WedgeState = emptyWedge

    function onKeyDown(event: KeyboardEvent) {
      if (isTyping(event.target)) return
      if (event.ctrlKey || event.metaKey || event.altKey) return

      const result = feedKey(state, event.key, event.timeStamp || performance.now())
      state = result.state
      if (result.code) {
        event.preventDefault()
        handler.current(result.code)
      }
    }

    document.addEventListener('keydown', onKeyDown)
    return () => document.removeEventListener('keydown', onKeyDown)
  }, [enabled])
}
